import TfLaunch from '@/micro-app/tf-launch';

const routeConfig = [
  {
    title: '自动选品',
    path: '/pdrauto',
    getLink({ path }) {
      return `${path}#/pandora-goods-pool`;
    },
    component: TfLaunch,
  },
  {
    title: '人工选品',
    path: '/pdrmanual',
    getLink({ path }) {
      return `${path}#/pandora-goods-pool/manual`;
    },
    component: TfLaunch,
  },
  {
    title: '聚合商品池',
    path: '/pdrcollection',
    getLink({ path }) {
      return `${path}#/pandora-goods-pool/aggregation`;
    },
    component: TfLaunch,
  },
];

export default routeConfig;
